import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import { Ionicons } from '@expo/vector-icons';

export const Advice = ({ icon, label, description }) => {
    return (
      <View style={styles.container}>
        <View style={styles.square}>
          <Text style={styles.text}>{description}</Text>
        </View>
        <View style={styles.circleContainer}>
          <View style={styles.circle}>
            <View style={styles.iconContainer}>
            <Ionicons name={icon} size={50} color="white" />
              <Text style={styles.label}>{label}</Text>
            </View>
          </View>
        </View>
      </View>
    );
  };

const styles = StyleSheet.create({
  container: {
    alignItems: 'center',
    width: '100%'
  },
  square: {
    width: '40',
    borderRadius: 12,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#EFE5DA',
    paddingTop: 70,
    padding: 40,
    //marginTop:70,
    marginBottom: 80
  },
  text: {
    textAlign: 'center',
    fontFamily: 'DM Sands',
    fontSize: 20,
    lineHeight: 31.25,
    color: '#3B1C15',
    textAlign: 'left'
    //fontWeight: 400
  },
  circleContainer: {
    position: 'absolute',
    top: -80,
    alignItems: 'center',
  },
  circle: {
    justifyContent: 'center',
    alignItems: 'center',
    width: 150,
    height: 150,
    borderRadius: 100,
    backgroundColor: '#9EA698',
  },
  iconContainer: {
    justifyContent: 'center',
    alignItems: 'center',
  },
  label: {
    marginTop: 10,
    color:'#FFFDFA',
    fontFamily:'DM Serif Display',
    fontSize: 20,
    fontWeight: 400,
    textAlign: 'center',
  },
});

